import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoaderComponent } from '@mode/shared/ui';

@Component({
  standalone: true,
  selector: 'mode-viz-loader',
  imports: [CommonModule, LoaderComponent],
  templateUrl: './viz-loader.component.html',
  styleUrls: ['./viz-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VizLoaderComponent {
  @Input() showLongLoadTimeMsg = false;
}
